import { render, staticRenderFns } from "./AppLayoutFooter.vue?vue&type=template&id=012d0bba&scoped=true&"
import script from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./AppLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutFooter.vue?vue&type=style&index=0&id=012d0bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d0bba",
  null
  
)

export default component.exports